import { makeStyles } from "@material-ui/core";
import { useSnackbar } from "notistack";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { post } from '../../utils/axiosInstance';
import AboutTheCourse from "./AboutTheCourse";
import ConnectUs from "./ConnectUs";
import CourseDesign from "./CourseDesign";
import GetHired from "./GetHired";
import HowAreWeDiffrent from "./HowAreWeDiffrent";
import HowItWorks from "./HowItWorks";
import OurClients from "./OurClients";
import OurInstructors from "./OurInstructors";
import Syllabus from "./Syllabus";
import TrackPitch from "./TrackPitch";
import { useRef } from "react";
import TrackDetails from "../TrackDetails";
import LoginModal from "../../Components/LoginModal";
import { moveToProvidedRef } from "../../utils/helper";
import TracksFAQs from "./TracksFAQs";

const useStyles = makeStyles((theme) => ({
    root: {
        '& section': {
            [theme.breakpoints.down("sm")]: {
                margin: '2rem auto 0 auto',
                padding: '4rem 2rem 1rem 2rem',
            },
            margin: '5rem auto 0 auto',
            padding: '2rem 6rem',
        },
        '& section:nth-child(odd)': {
            backgroundColor: '#F3F6FC',
        },
        '& h1': {
            marginTop: 0,
            fontSize: '2.5rem',
        },
        '& h2': {
            margin: 0,
            fontSize: '2rem',
        },
        '& h3': {
            margin: 0,
            fontSize: '1.5rem',
        },
        '& h4': {
            margin: 0,
            fontSize: '1rem',
        },
        '& span': {
            fontSize: '1rem',
        },
        '& p': {
            fontSize: '1rem',
        }
    },
    loadingText: {
        textAlign: 'center'
    },
    textInfoContainers: {
        display: 'flex',
        gap: '1rem',
        alignItems: 'center',
        justifyContent: 'space-around',
        '& div': {
            flexBasis: '45%'
        }
    },
    lightBoxShadowForPills: {
        boxShadow: 'rgba(0, 0, 0, 0.05) 0px 1px 2px 0px',
    },
    customScroll: {
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            width: '5px',
            height: '5px',
        },
        '&:hover::-webkit-scrollbar-thumb': {
            borderRadius: '5px',
            background: '#707070',
        },
        '&:hover::-webkit-scrollbar-track': {
            borderRadius: '5px',
            boxShadow: 'inset 0 0 3px grey',
        },
        '&::-webkit-scrollbar-thumb:hover': {
            background: '#8b8b8b',
        },
    }
}))

const Home = (props) => {

    const classes = useStyles();
    const trackname = props.match.params.trackname;
    const { enqueueSnackbar } = useSnackbar();
    const [trackDetails, setTrackDetails] = useState();
    const history = useHistory();

    const productsRef = useRef();
    const [openConsultationModal, setOpenConsultationModal] = useState(false);

    useEffect(() => {
        post('getTrackDetails', { title: trackname })
            .then((res) => {
                setTrackDetails(res?.data?.output);
            })
            .catch((err) => {
                history.replace('/');
                enqueueSnackbar(`Error occurred while fetching tracks details please try again after some time.`, {
                    variant: 'error',
                    autoHideDuration: 4000,
                });
            })
    }, [trackname])

    const helperClasses = {
        textInfoContainers: classes.textInfoContainers,
        lightBoxShadowForPills: classes.lightBoxShadowForPills,
        heading1Style: classes.heading1Style,
        customScroll: classes.customScroll
    }

    const showContactForm = () => {
        setOpenConsultationModal(true);
    }

    if (trackDetails && !trackDetails?.showNewLandingPage) {         // trackDetails?.showOldPages
        return <TrackDetails trackDetails={trackDetails} />
    }

    return (
        <section className={classes.root}>
            {!trackDetails ? <p className={classes.loadingText}>Loading...</p>
                :
                <>
                    <TrackPitch
                        trackPitch={trackDetails?.trackPitch}
                        moveToProducts={() => moveToProvidedRef(productsRef, 70)}
                        {...helperClasses}
                    />
                    <AboutTheCourse landingPageInfo={trackDetails?.landingPageInfo} keyPoints={trackDetails?.keyPoints.values} {...helperClasses} />
                    <Syllabus categories={trackDetails?.categories} />
                    <CourseDesign courseDesign={trackDetails?.courseDesign?.values} {...helperClasses} />
                    <HowItWorks ourProcesses={trackDetails?.ourProcess.values} />
                    <OurInstructors experts={trackDetails?.expertIds} />
                    <HowAreWeDiffrent />
                    <OurClients successStories={trackDetails?.successStories} />
                    {trackDetails?.faqs?.length > 0 && <TracksFAQs faqs={trackDetails?.faqs} {...helperClasses} />}
                    <GetHired
                        productInfo={trackDetails?.productInfo}
                        currTrackDetails={trackDetails}
                        productsRef={productsRef}
                        helperClasses={helperClasses}
                        showContactForm={showContactForm}
                    />
                    <ConnectUs />
                </>
            }
            <LoginModal
                open={openConsultationModal}
                handleClose={() => { setOpenConsultationModal(false) }}
                focusForm={true}
                resetFocusForm={() => { }}
                email={""}
                setEmail={(e) => { }}
                isCalendlyModal={false}
                calendlyPrefillData={{}}
                setCalendlyPrefillData={() => { }}
            />
        </section>
    )
}

export default Home;